import React from "react";
import FancyLink from "../_shared/FancyLink";
import Spacing from "../_shared/Spacing";
import s from "./Banner.module.css";

function Banner({ links, icon, description, logo, spacing }) {
  return (
    <Spacing value={spacing}>
      <div className={s.banner}>
        <div className={s.section}>
          {links.map((l, idx) => (
            <FancyLink key={idx} blackLabel {...l} />
          ))}
        </div>
        <div className={[s.section, s["last-mile"]].join(" ")}>
          <div className={s["inner-section"]}>
            {icon && <img className={s.icon} src={icon} />}
            {description && <div>{description}</div>}
          </div>
          {logo && <img className={s.logo} src={logo} />}
        </div>
      </div>
    </Spacing>
  );
}

export default Banner;
